import { render, staticRenderFns } from "./LoyaltyNotifyUpsert.vue?vue&type=template&id=2b366d41&"
import script from "./LoyaltyNotifyUpsert.vue?vue&type=script&lang=js&"
export * from "./LoyaltyNotifyUpsert.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyNotifyUpsert.vue?vue&type=style&index=0&id=2b366d41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports